export default {
  account_required: 'Sila masukkan Nama Pengguna',
  password_required: 'Sila masukkan Kata Laluan',
  confirm_password_different: 'Pengesahan Kata Laluan tidak sepadan dengan Kata Laluan',
  min_length: "Mestilah mengandungi 6 aksara atau ke atasnya",
  alphanumeric_char: "Hanya aksara angka abjad diterima",
  list:{
    0: "Sesi sudah tamat, sila log masuk semula",
    OK: "Kod TAC telah berjaya dihantar", // for tac code
    ok: "Kod TAC telah berjaya dihantar", // for tac code
    CLOSE: "Sorry! Nampaknya ada masalah teknikal dengan login anda. Sila hubungi livechat kami untuk maklumat lanjut.",
    close: "Sorry! Nampaknya ada masalah teknikal dengan login anda. Sila hubungi livechat kami untuk maklumat lanjut.",
    accountIdRequired: 'Sila masukkan Nama Pengguna',
    passwordStrengthError: 'Kata Laluan mestilah mengandungi 6 - 20 aksara serta kombinasi angka dan huruf',
    session_expired : 'Sesi tamat tempoh',

    app_id_required: "ID Permohonan diperlukan",
    permission_denied: "Kebenaran ditolak",
    account_id_required: "ID Akaun/Nama Pengguna diperlukan",
    verification_code_required: "Kod Pengesahan diperlukan",
    account_not_exists: "Nama Pengguna/Akaun tidak wujud",
    account_inactive: "Nama Pengguna/Akaun tidak aktif",
    verify_failed: "Process Pengesahan gagal",
    parent_account_inactive: "Akaun Induk tidak aktif",
    transfer_id_required: "ID Pindahan diperlukan",
    credit_amount_required: "Jumlah Kredit diperlukan",
    duplicate_credit_record: "Rekod Kredit Pendua ditemui",
    member_wallet_not_exists: "Dompet Ahli tidak wujud",
    debit_amount_required: "Jumlah Debit diperlukan",
    duplicate_debit_record: "Rekod Debit Pendua ditemui",
    insufficient_balance: "Baki sedia ada tidak mencukupi",
    result_exists: "Rekod Keputusan telah wujud",
    debit_record_not_found: "Rekod Debit tidak dapat dicari",
    bank_id_required: "ID Bank diperlukan",
    bank_acc_no_required: "Nombor Akaun Bank diperlukan",
    bank_acc_holder_required: "Nama Pemegang Akaun bank diperlukan",
    bank_already_setup: "Akaun Bank telahpun disetkan",
    platform_required: "Platform diperlukan",
    parent_not_exists: "Induk tidak wujud",
    invalid_password: "Kata Laluan tidak sah",
    parent_id_required: "ID Induk diperlukan",
    password_required: "Kata Laluan diperlukan",
    contact_phone_required: "Nombor Telefon diperlukan",
    account_exists: "ID Akaun/Pengguna telah wujud",
    vip_mode_not_exists: "Mod VIP tidak wujud",
    session_not_exists: "Sesi sudah tamat, sila log masuk semula",
    ticket_id_required: "ID Tiket diperlukan",
    ref_id_required: "ID Rujukan diperlukan",
    ticket_not_exists: "Tiket tidak wujud",
    ticket_processed: "Tiket telahpun diproses",
    min_deposit_not_met: "Jumlah deposit yang dimasukkan mestilah sekurang-kurangnya senilai dengan jumlah minimum",
    ongoing_promotion: "Anda masih menyertai dalam promosi yang sedang dijalankan. Sila menuntut tawaran bonus yang lain selepas ini",
    invalid_promo_package: "Pakej promosi tidak sah",
    promo_min_deposit_not_met: "Jumlah deposit tidak memenuhi syarat promosi",
    claim_promo_only_once_a_day: "Tawaran promosi hanya boleh dituntut sekali sahaja dalam sehari",
    first_deposit_unmet: "Deposit harian kali pertama telahpun dituntut",
    newbie_unmet: "Ganjaran deposit kpd Pemain Baru telahpun dituntut",
    claim_promo_only_once: "Tawaran promosi ini hanya boleh dituntut sekali sahaja",
    inner_catch: "Kesalahan tidak Dijangka",
    systemError: "Kesalahan sistem",
    deposit_amount_required: "Jumlah deposit diperlukan",
    target_bank_id_required: "ID Bank Sasaran diperlukan",
    target_bank_acc_no_required: "Nombor Akaun Bank Sasaran diperlukan",
    target_bank_acc_holder_required: "Nama Pemegang Akaun Bank Sasaran diperlukan",
    deposit_date_required: "Tarikh pendepositan diperlukan",
    deposit_method_required: "Kaedah Deposit diperlukan",
    min_deposit_not_set: "Jumlah Deposit Minimum masih belum ditetapkan",
    min_balance_not_set: "Baki sedia ada minimum masih tidak ditetapkan",
    ibank_account_not_exists: "Akaun IBANK88 tidak wujud",
    ibank_account_inactive: "Akaun IBANK88 tidak aktif",
    withdrawal_amount_required: "Jumlah pengeluaran diperlukan",
    min_withdrawal_not_set: "Jumlah pengeluaran minimum masih belum ditetapkan",
    bank_member_not_exists: "Akaun Bank Ahli Sasaran tidak wujud",
    promotion_requirement_not_met: "Masih tidak memenuhi keperluan promosi",
    invalid_promotion: "Tawaran promosi tidak sah ",
    new_password_required: "Kata Laluan baru diperlukan",
    multiplier_not_found: "Sistem tidak mampu proses permintaan anda pada masa ini, sila cuba sebentar lagi",
    contact_phone_exists: "Nombor telefon telah didaftar",
    BLOCK: "Akaun anda telah digantung",
    tac_is_valid: "Kod TAC anda sebelum ini masih sah",
    tac_expired: "Kod TAC anda telah luput, sila dapatkan Kod TAC baru",
    invalid_tac: "Kod TAC tidak sah",
    tac_not_validate: "Kod TAC masih belum disahkan",
    tacCodeRequired: "Sila masukkan Kod TAC",
    invalid_referral_code: "Kod Pengajakan tidak sah",
    exceed_max_withdrawal: "Lebih daripada jumlah Pengeluaran maksimum",
    bank_member_inactive: "Bank Pengguna tidak aktif",
    loginFailed: "Tidak dapat Log Masuk",
    loginSucceed: "Berjaya Log Masuk",
    usernameRequired : "Sila masukkan Nama Pengguna",
    passwordRequired : "Sila masukkan Kata Laluan",
    logoutSucceed : "Berjaya Log Keluar",
    logoutFailed : "Tidak dapat Log Keluar",
    requestSucceed: "Permintaan berjaya dihantar",
    requestFailed : "Permintaan gagal dihantar",
    requestProcessing : "Permintaan anda sedang diproses",
    requestDelayed: "Permintaan ditunda",
    verificationCodeRequired: "Pengesahan Kod TAC diperlukan",
    newPasswordRequired: "Kata Laluan Baru diperlukan",
    bankIdRequired: "Sila pilihkan Bank",
    bankNameRequired: "Nama Bank diperlukan",
    bankAccHolderRequired : "Nama Pemegang Akaun Bank diperlukan",
    bankAccNoRequired: "Nombor Akaun Bank diperlukan",
    depositAmountRequired: "Sila masukkan jumlah deposit",
    dateRequired: "Sila pilihkan Tarikh",
    bonusIdRequired: "Sila putuskan pemberian yang dituntut",
    bank_member_exists: "Akaun Bank sudah didaftar",
    never_deposited : "Anda mestilah melakukan sekurang-kurangnya sekali pendepositan sebelum membuat pindahan kepada rakan mainanmu",
    transferAmountMustGreaterThanEqual5: "Jumlah pindahan mestilah senilai dengan atau melebihi daripada RM 5",
    invalid_transfer_amount: "Jumlah pindahan mestilah senilai dengan atau melebihi daripada RM 5",
// account_not_exists : "akaun tidak wujud"
    permission_denied : "Akaun penerima bukan dari laman web yang sama",
    ongoing_promotion : "Anda masih menyertai dalam promosi yang sedang dijalankan",
    insufficient_balance : "Baki tidak mencukupi",
    transfer_success: "Pindahan berjaya dilakukan",
    sender_id_required: "ID pengirim diperlukan",
    recipient_id_required: "ID penerima diperlukan",
    tac_validated: "Kod TAC masih dalam tempoh sah laku.",
    pending_result_in_game: "Keputusan perlawanan masih belum dimuktamadkan",
    accountIdOnlyNumber: "Hanya untuk nombor telefon sah dan aktif sahaja",
    unfinishgamedetected: "Sila menghabiskan permainan percuma ini sebelum menyusul langkah ini",
    duplicate_review: "Anda telahpun menghantar ulasan sebelum ini",
    exceed_withdrawal_frequency: "Anda telah capai had bilangan pengeluaran harian. (5 kali sehari)",
    requestTooFrequentAtLeast2Minutes: "Permintaan anda sedang diproses",
    invalidPhoneNumberFormat: "Nombor telefon tidak sah",
    gspayUnderMaintenance: "Sistem Dalam Penyelenggaraan",
    affiliate_not_exists: " Kod sekutu tidak sah",
    phoneRequired: 'Sila isi nombor telefon',
    couponeCodeRequired: "Kod Kupon diperlukan",
    coupon_code_required: "Kod Kupon diperlukan",
    coupon_not_available: "Kod Kupon tidak sah",
    contact_email_registered: "Alamat e-mel telah digunakan",
    invalidEmailFormat: "Alamat e-mel tidak sah",
    emailRequired: "Sila masukkan alamat e-mel",
    paymentMethodRequired: "Sila Pilih Kaedah Pembayaran",
    depositMethodRequired: "Sila Pilih Cara Deposit",
    telcoCodeRequired: "Sila pilih telco",
    reloadPinCodeRequired: "Sila isi reload pin",
    attachment_path_required: "Sila muat naik resit transaksi anda.",
    free_credit_detected: "Kredit Percuma Khas Untuk Permainan EpicWin Sahaja.",

    //new
    amount_required: "Amaun diperlukan",
    auth_token_required: "Token sesi diperlukan",
    bet_id_required: "ID pertaruhan diperlukan",
    bonus_unavailable: "Tiada bonus",
    client_ip_required: "Alamat IP diperlukan",
    first_deposit_not_met: "Deposit pertama diperlukan",
    ftd_required: "Deposit pertama diperlukan",
    game_maintenance: "Kerja penyelenggaran sedang dijalankan. Sila cuba sebentar lagi",
    gateway_acc_required : "Akaun gerbang pembayaran diperlukan",
    inbox_id_required: "ID peti masuk diperlukan",
    insufficient_rebate: "Kekurangan rebat",
    insufficient_ticket: "Kekurangan tiket",
    is_default_required: "Pilihan tetap diperlukan",
    min_withdrawal_not_met: "Pengeluaran minimum tidak dicapai",
    newbie_not_met: "Kriteria promosi orang baru tidak dicapai",
    no_changes: "Pilihan bank tetap tidak berubah",
    promotion_not_available:"Tiada promosi",
    ref_no_required: "Nombor rujukan diperlukan",
    result_id_required: "ID keputusan diperlukan",
    search_id_required: "ID carian diperlukan",
    setting_not_set: "Seting tidak dikonfigurasikan",
    tac_required: "Kod tac diperlukan",
    ticket_count_required: "Jumlah tiket diperlukan",
    vip_not_exists: "Bukan ahli VIP",
    working_date_required: "Tarikh bekerja diperlukan",
    working_month_required: "Bulan bekerja diperlukan",
    withdrawal_amount_lte_withhold_amount: "Jumlah pengeluaran yang lebih kurang atau sama dengan jumlah yang dipegang",
    providerRequired: "Pengendali diperlukan",
    invalid_contact_email: "Email tidak sah",
    invalidUsernameFormat: "Format nama pengguna tidak sah",
    affiliate_inactive: "Ahli gabungan tidak aktif",
    insufficient_token: "Kekurangan token",
    LaunchGameFailed: "Permainan gagal dilancarkan",
    "System Error": "Ralat sistem",
    "Server Busy": "Server Sibuk",
    "SERVER BUSY": "Server Sibuk",
    "Not Available": "Tidak Tersedia",
    undefined: "Sila periksa sambungan Internet anda dan cuba lagi",
    disconnect: "Sila periksa sambungan Internet anda dan cuba lagi",
    unableToLaunchSlotGameAtTheMoment: "Tidak dapat melancarkan permainan pada masa ini",
    launch_fail: "Ralat melancarkan permainan, sila hubungi admin",
    playerCreatedError: "Ralat melancarkan permainan, sila hubungi admin",
    "Launch Fail": "Ralat melancarkan permainan, sila hubungi admin",
    currencyNotSupported : "Mata wang tidak disokong",
    game_not_supported:"Permainan tidak disokong dalam bonus yang anda tuntut.",
    pending_deposit: "Deposit Tertunda",
    "Launch Game Failed" : "Pelancaran Permainan Gagal",
  },
  processing: "Terima Kasih, transaksi anda sedang diproses",
  url:{
    mseric1: "http://172.12.5.200:8100/",
    mseric2: "http://172.12.5.200:8101/",
    epicvip: "https://epicwin.vip/",
    epicinfinity: "https://epicwin8.com/",
    epicwin2: "https://epicwin2.com/"
  },
  wrong_site: {
    description: "Akaun anda dimiliki oleh ",
    mseric1: "EpicWinVip",
    mseric2: "EpicWin8",
    epicvip: "EpicWinVip",
    epicinfinity: "EpicWin8",
    epicwin2: "EpicWin2"
  },
  wrong_filetype: "Fail Tidak Sah",

  newpw_required: "Sila masukkan Kata Laluan Baru",
  newpw_notsame: "Kata Laluan baru tidak boleh sama dengan Kata Laluan Semasa",

  oldpw_required: "Sila masukkan Kata Laluan Semasa.",

  pw_notmatched: "Pengesahan Kata Laluan tidak sepadan dengan Kata Laluan Baru",

  forgot_password_success: "Kata laluan sementara telah dihantar ke nombor telefon anda melalui SMS. Sila gunakan kata laluan ini untuk log masuk.",
  change_password_success: "Kata Laluan berjaya dikemaskini!!",
  add_bank_success: "Akaun Bank Baru berjaya ditambah!!",

  tac_tooltips: "Kod TAC telah dihantar ke nombor telefon anda.",
  tac_tooltips1: 'Klik "Hantar Semula" untuk dapatkan Kod TAC baru',
  tac_countdown: "Hantar TAC code baru dalam {countdown}",

  bank_details_tooltips: "Transaksi pengeluaran anda akan ditolak, jika Nama Bank Akaun anda tidak sepadan dengan Nama Penuh terdaftar di EpicWin.",
  copy_clipboard: "Salinan Pautan",

  about_us_1: "<h1>PENGELUARAN SEGERA</h1><p>Masa pemprosesan yang cepat dengan proses yang dapat mengurangkan masa dan lut sinar dalam melakukan pengeluaran segera</p><h1>PASTINYA BENAR</h1><p>Keseluruhan EpicWin sememangnya lut sinar, maka kesemuanya jelas dan mudah, adil dan ringkas di sini.</p>",
  about_us_2: "<h1>ANDA MEMENANGINYA, ANDA DAPATKANNYA</h1><p>Kami mempercayai bahawa memberi ganjaran yang setimpal kepada mereka yang sepatutnya diganjar. Sebab itulah kami menetapkan syarat jumlah kemenangan yang lebih rendah dan mengganjar pemberian hadiah wang kepada anda pada setiap kali anda bertaruh dalam permainan.</p>",
  about_us_3: "<h1>MEMILIKI KESEMUANYA</h1><p>Kami memberikan kawalan kepada anda. Wang anda tetap MILIKMU, ambilkannya, bertaruh dengannya atau buat apa saja  sesuka hati dengannya.<br/>Kami berasa bahawa semakin kerap anda bertaruh, semakin hebat pulangan yang anda sepatutnya perolehi: lebih menyeronokkan dan banyak lagi ganjaran.<br/>Sudahkah anda siap sedia untuk melepaskan diri anda daripada cengkaman kehidupan harian dengan hiburan yang lebih menghiburkan dan berhasil?</p>",

  promo_1_title: "TAWARAN KREDIT TARUHAN PERCUMA",
  promo_1a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>TAWARAN KREDIT TARUHAN PERCUMA BERJUMLAH RM 100</div><div class='package-table'><div class='row title'><div class='col-4'>Taruhan Percuma</div><div class='col-4'>Syarat Kemenangan yg. Ditetapkan</div><div class='col-4'>Jumlah Pengeluaran yg. Dihadkan</div></div><div class='row table-row'><div class='col-4'>100</div><div class='col-4'>500</div><div class='col-4'>10</div></div></div>",
  promo_1b: "<h1>TERMA &amp; SYARAT PROMOSI</h1><ul><li>Jumlah kemenangan yang ditetapkan adalah RM 500 manakala jumlah pengeluaran maksimum yang dihadkan di bawah rangka promosi ini adalah RM 10.</li><li>Baki kemenangan akan dikosongkan selepas pengeluaran kredit taruhan.<li>Pemain yang menuntut kredit taruhan percuma tidak berkelayakan untuk menuntut ganjaran promsi yang lain sehingga berjaya memenuhi jumlah kemenangan yang ditetapkan di bawah rangka promosi ini.</li><li>Tawaran Kredit Taruhan Percuma tidak boleh digunakan bersama dengan promosi yang lain. Deposit yang dilakukan oleh pemain akan dilupuskan secara automatik jika pemain didapati menggunakannya untuk menuntut promosi berbilang pada waktu syang sama.</li></ul></h1>",
  general: "<h1>TERMA &amp; SYARAT PROMOSI UMUM</h1><ul><li>Setiap pemain hanya dibenarkan untuk membuat permohonan pengeluaran wang sebanyak 5 kali sahaja dalam sehari.</li><li>Semua promosi tertakluk kepada TERMA &amp; SYARAT PROMOSI UMUM yang diterbitkan di EpicWin.</li></ul>",

  promo_2_title: "BONUS RUJUKAN",
  promo_2a: {
    title1: "Kriteria",
    title2: "Ganjaran",
    details1: "Sebarang Jumlah Deposit Dari Rakan",
    details2: "10% Rebat Tunai",
    details3: "Deposit Kali Pertama Dibuat oleh Rakan Dirujuk ",
    details4: "1 keping Tiket Jackpot",
    details5: "40 Rujukan Yang Berkelayakan",
    details6: "1 keping Tiket Jackpot",
    tnc: "TERMA & SYARAT PROMOSI",
    tnc_details0: "Setiap pemain hanya dibenarkan untuk membuat permohonan pengeluaran wang sebanyak 5 kali sahaja dalam sehari.",
    tnc_details1: "Nikmati Rebat Tunai 10% hingga RM20 bagi deposit dibuat oleh setiap rakan rujukanmu.(tak kira jumlah)",
    tnc_details2: "Mempelawa dan merujuk sekurang-kurangnya 3 org. rakan mainan. Anda akan diganjar 1 keping Tiket Jackpot sebagai pemberian ketika rakan yg. dirujuk membuat deposit kali pertama sekurang-kurangnya RM 30.",
    tnc_details3: "Jumlah hadiah wang yang boleh dimenangi dengan putaran percuma dihadkan kepada RM10 (1000 token)",
    // tnc_details4: "Tawaran Rebat Tunai 10% tertakluk kepada 1 kali kemenangan sebelum permohonan pengeluaran dibenarkan.",
  },

  promo_3_title: "BONUS SAMBUTAN",
  promo_3_title_full: "BONUS SAMBUTAN SEKALIGUS",
  promo_3a: {
    title1: "Deposit",
    title2: "%",
    title3: "Bonus",
    title4: "Deposit Permulaan",
    title5: "Jumlah Kemenangan",
    details0_1: "10",
    details0_2: "100%",
    details0_3: "10",
    details0_4: "20",
    details0_5: "x3",
    details1_1: "30",
    details1_2: "100%",
    details1_3: "30",
    details1_4: "60",
    details1_5: "x2",
    details2_1: "100",
    details2_2: "120%",
    details2_3: "120",
    details2_4: "220",
    details2_5: "x3",
    details3_1: "300",
    details3_2: "150%",
    details3_3: "450",
    details3_4: "750",
    details3_5: "x5",
    details4: "* Sila hubungi livechat untuk klaim bonus sambutan 100% deposit RM10 dapat RM20.",
    tnc: "TERMA & SYARAT PROMOSI",
    tnc_details0: "Setiap pemain hanya dibenarkan untuk membuat permohonan pengeluaran wang sebanyak 5 kali sahaja dalam sehari.",
    tnc_details1: "Hanya boleh tuntut SATU tawaran bonus sahaja",
    tnc_details2: "Hanya ditawarkan SEKALI sahaja ke atas Pendepositan kali Pertama.",
    tnc_details3: "Mestilah mencapai syarat bg. jumlah kemenangan yang ditetapkan sebelum pengeluaran diluluskan",
  },

  promo_4_title: "BONUS DEPOSIT HARIAN",
  promo_4a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>Bonus Deposit Harian</div><div class='package-table'><div class='row title'><div class='col-2'>Jumlah Deposit</div><div class='col-2'>Ganjaran Bonus</div><div class='col-2'>Jumlah Bonus</div><div class='col-2'>Baki Permulaan</div><div class='col-2'>Jumlah Pengeluaran</div></div><div class='row table-row'><div class='col-2'>10</div><div class='col-2'>20%</div><div class='col-2'>2</div><div class='col-2'>12</div><div class='col-2'>24</div></div><div class='row table-row'><div class='col-2'>30</div><div class='col-2'>10%</div><div class='col-2'>3</div><div class='col-2'>33</div><div class='col-2'>66</div></div><div class='row table-row'><div class='col-2'>50</div><div class='col-2'>10%</div><div class='col-2'>5</div><div class='col-2'>55</div><div class='col-2'>110</div></div><div class='row table-row'><div class='col-2'>100</div><div class='col-2'>10%</div><div class='col-2'>10</div><div class='col-2'>110</div><div class='col-2'>220</div></div><div class='row table-row'><div class='col-2'>200</div><div class='col-2'>10%</div><div class='col-2'>20</div><div class='col-2'>220</div><div class='col-2'>440</div></div><div class='row table-row'><div class='col-2'>300</div><div class='col-2'>10%</div><div class='col-2'>30</div><div class='col-2'>330</div><div class='col-2'>660</div></div></div>",
  promo_4b: "<h1>TERMA &amp; SYARAT PROMOSI</h1><ul><li>Ganjaran Bonus 20% adalah tawaran masa terhad di mana pemain boleh menuntut ganjaran ini SEKALI sahaja dalam sehari and can only be claimed by a member ONCe per day (Frekuensi keberlakuan diset semula setiap hari selepas pukul 12 tgh. mlm.).</li><li>Jumlah deposit minimum per transaksi adalah RM 10, manakala tiada had ditetapkan bagi jumlah deposit harian yang dilakukan di bawah rangka promosi ini.</li><li>Permohonan pengeluaran bagi tawaran ganjaran ini adalah tertakluk kepada 2 kali kemenangan atas baki akaun.</li></ul>",

  promo_5_title: "DEPOSIT AM",
  promo_5a:{
    title1: "Deposit",
    title2: "Tiket Jackpot Percuma",
    details1_1: "10",
    details1_2: "50",
    details2_1: "100",
    details2_2: "200",
    details3_1: "500",
    details3_2: "1000",
    details4_1: "500",
    details4_2: "10",
    details5_1: "1000",
    details5_2: "13",
    // details6_1: "2000",
    // details6_2: "10 kali Putaran Percuma Premium",
    // details7_1: "3000",
    // details7_2: "12 kali Putaran Percuma Premium",
    // details8_1: "5000",
    // details8_2: "25 kali Putaran Percuma Premium",
    // details9_1: "10000",
    // details9_2: "50 kali Putaran Percuma Premium",
    // details3: "MYR 10",
    description1: "Bonus Tanpa Deposit hanya sesuai digunakan untuk situasi-situasi berikut:",
    description1_1: "(i) Baki kurang daripada RM5",
    description1_2: "(ii) Pengeluaran",
    description1_3: "(iii) Baki Sifar",
    tnc: "TERMA & SYARAT PROMOSI",
    tnc_details0: "Setiap pemain hanya dibenarkan untuk membuat permohonan pengeluaran wang sebanyak 5 kali sahaja dalam sehari.",
    tnc_details1: "Anda dikehendaki memenuhi 1 kali pusing ganti sebelum penyerahan permohonan pengeluaran.",
    // tnc_details2: "Baki Kemenangan akan dikosongkan sesudah pengeluaran berjaya dilakukan.",
    // tnc_details3: "Ahli yang menuntut tawaran Kredit Percuma tidak berkelayakan menuntut ganjaran promosi yang lain sehingga ahli tersebut berjaya memenangi jumlah hadiah kemenangan yang ditetapkan di bawah rangka promosi ini.",
    // tnc_details4: "Tawaran Kredit Percuma tidak boleh digunakan bersama dengan promosi-promosi yang lain. Jika ahli didapati menggunakan jumlah deposit yang sama untuk menuntut lebih daripada tawaran promosi akan mengakibatkan jumlah pendepositannya dilupuskan.",
    // tnc_details5: "Anda dikehendaki memenuhi 1 kali pusing ganti sebelum penyerahan permohonan pengeluaran."
  },
  promo_5b: "<h1>TERMA &amp; SYARAT PROMOSI</h1><ul><li>Permohonan pengeluaran bagi tawaran ganjaran ini hanya perlu memenuhi 1 kali tuntutan pusingan sahaja.</li></ul>",

  player_transfer: "<h1>TERMA &amp; SYARAT PROMOSI</h1><ul><li>Kedua-dua pengirim dan penerima mestilah menjadi pemain yang mendeposit bersama dengan EpicWin.</li><li>Kedua-dua pengirim dan penerima hanya boleh melakukan pindahan dalam keadaan di mana tidak menuntut sebarang promosi.</li><li>Jumlah Pindahan Minimum: RM 5.</li><li>Yuran Pindahan: RM 0.20 per transaksi (caj kepada penerima)</li><li>Semua transaksi yang tidak sah/gagal akan dikredit kembali kepada pengirim secara automatik.</li></ul></h1>",
  promo_6_title: "BONUS VIP",
  promo_6a: "<div class='promo-title text-uppercase mb-3 promo-modal-title'>BONUS VIP</div><div class='package-table'><div class='row title'><div class='col-3'>Jumlah Deposit</div><div class='col-3'>Jumlah Bonus</div><div class='col-3'>Baki Permulaan</div><div class='col-3'>Jumlah Pengeluaran</div></div><div class='row table-row'><div class='col-3'>1000</div><div class='col-3'>1500</div><div class='col-3'>2500</div><div class='col-3'>7500</div></div></div>",
  promo_6b: "<h1>TERMA &amp; SYARAT PROMOSI</h1><ul><li>Setiap pemain hanya dibenarkan untuk menuntut SEKALI sahaja di sepanjang tempoh promosi.</li><li>Permohonan pengeluaran bagi tawaran ganjaran ini adalah tertakluk kepada 3 kali kemenangan atas baki akaun.</li></ul>"
  
};
